export * from './floating-panel.module';
export * from './floating-panel.component';
